import { render, staticRenderFns } from "./NoResults.vue?vue&type=template&id=66ec6232&"
import script from "./NoResults.vue?vue&type=script&lang=ts&"
export * from "./NoResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports